export default () => Math.ceil(Math.random() * 100000) // TODO: uuid()
